import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";
 
export default () => {

  const moduleName = "sliders";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.sliders_destroy, location.search]);

  useEffect(() => {
    if (appReducer.sliders_list != undefined) {
      setRows(appReducer.sliders_list.data)
      setTotalPages(appReducer.sliders_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name ?? "-",
    },
    {
      name: 'تصویر',
      selector: row => row.image_full ? <img className="w-24 mt-4" src={row.image_full} /> : "-"
    },
    {
      name: 'پروموشن',
      selector: row => row.is_promotion == "active" ? "بله" : "خیر"
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table count={totalPages} columns={columns} data={rows} />;

};
